import { ROLES } from '@/api/routes/users/types';

import { useAppSelector } from './redux-hooks';

const useRoleAccess = (
  requiredRoles: ROLES[],
  isStrict: boolean = false,
  additionalRequiredRoles: ROLES[] = [],
): boolean => {
  const { user } = useAppSelector((state) => state.currentUserReducer);
  if (!user) return false;

  const userRolesId = user?.roles.map((role) => role.id) || [];
  const isAdmin = userRolesId.includes(ROLES.ADMIN);
  const roleMatch = isStrict
    ? requiredRoles.every((role) => userRolesId.includes(role))
    : requiredRoles.some((role) => userRolesId.includes(role));

  const isAdditionalRoles = additionalRequiredRoles.every((role) => userRolesId.includes(role));

  if (additionalRequiredRoles.length) {
    return isAdmin || roleMatch || isAdditionalRoles;
  }

  return isAdmin || roleMatch;
};

export default useRoleAccess;
